export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7220.e0335f94.jpg";